import { HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom, skipWhile, take } from 'rxjs';
import { AuthState, selectActiveAccount } from '../../../core/auth/auth.reducer';
import { PaginationResponse } from '../../../shared/models/pagination-response.model';
import { ServiceRequest } from '../service-request.model';
import { ServiceRequestService } from '../service-request.service';

export const serviceRequestsResolver: ResolveFn<PaginationResponse<ServiceRequest[]>> = async (
  route: ActivatedRouteSnapshot
): Promise<PaginationResponse<ServiceRequest[]>> => {
  const _serviceRequestService: ServiceRequestService = inject(ServiceRequestService);
  const _store: Store<AuthState> = inject(Store<AuthState>);

  let searchParams!: HttpParams;

  if (route.queryParams['filter']) {
    searchParams = new HttpParams();
    route.queryParams['filter'].split('&').forEach((param: string) => {
      const [key, value] = param.split('=');
      searchParams = searchParams.append(key, value);
    });
  } else {
    searchParams = new HttpParams();

    searchParams = searchParams.append('status', 'New');
    searchParams = searchParams.append('status', 'Paused');
    searchParams = searchParams.append('status', 'Approved');
    searchParams = searchParams.append('status', 'Contested');
    searchParams = searchParams.append('status', 'Awaiting user');
    searchParams = searchParams.append('status', 'In progress');
    searchParams = searchParams.append('status', 'Committed');
    searchParams = searchParams.append('status', 'Blocked/Awaiting');
    searchParams = searchParams.append('sort', 'Id:desc');
  }

  // 31.10.2025 Max: I am doing this as a way to ensure that the user is logged in
  // This is necessary because otherwise the get request below runs before the user is logged in. Meaning you cannot reload the site
  await firstValueFrom(
    _store.select(selectActiveAccount).pipe(
      skipWhile(account => account === null || account === undefined),
      take(1)
    )
  );

  return await _serviceRequestService.get(1, searchParams);
};
